<template>
    <div class="adress">
        <tabbar msg="我的地址"></tabbar>

        <van-swipe-cell :right-width="120" :on-close="onClose" v-for="(item,idx) in address" :key="idx">
            <van-cell-group>
                <!-- <van-cell title="单元格" value="内容" /> -->
                <div class="box">
                    <div class="comtent" @click="checkAddress(idx)">
                        <div class="comtent1">
                            <span class="text_color333 text_size12" v-text="item.receiver"></span>
                            <span class="text_color333 text_size12" v-text="item.phone" style="color: #999"></span>
                        </div>
                        <div class="comtent2 text_color333 text_size12" v-text="item.address"></div>
                    </div>
                    <div :class="{check: true,act: item.isdefault == 1}" @click="checked(idx)">
                        <img :src="$store.state.api.imgUrl + 'cur_adress.png'" alt="" v-if="item.isdefault == 1" class="img">
                        <span class="img2" v-else></span>
                        默认地址
                    </div>
                </div>
            </van-cell-group>
            <div slot="right" class="right">
                <span  class="edit text_colorfff" @click="edit(item)">编辑</span>
                <span class="dele text_colorfff" @click="dele(item.addressId)">删除</span>
            </div>
        </van-swipe-cell>
        <div class="botBox bg_color1"></div>

        <div class="addAddress text_colorfff text_size14" @click="addAddress">
            + 添加新地址
        </div>
    </div>
</template>
<script>
    import './address.scss';
    import api from '@/utils/js/api.js';

    export default {
        data(){
            return {
                instance: '',
                userInfo: '',
                params: '',
                address: [
                    // {
                    // addressId: '1',
                    // receiver: '张三',
                    // phone: '13000000000',
                    // address : '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
                    // isdefault: 0
                    // },
                    // {
                    // addressId: '1',
                    // receiver: '张三',
                    // phone: '13000000000',
                    // address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 201 室',
                    // isdefault: 1
                    // }
                ]
            }
        },
        components:{

        },
        created(){
            this.userInfo = this.$store.state.userInfo || JSON.parse(localStorage.getItem('userInfo'));
            this.params = JSON.stringify(this.$route.query) != '{}' ? this.$route.query : this.$route.params;
            if(this.$store.state.address && this.params.target){
                this.address = this.$store.state.address;
            }else{
                this.queryAddressList()
            }
        },
        beforeMount(){
        },
        methods:{
            // 监听关闭
            onClose(clickPosition, instance){
                console.log(clickPosition, instance);
                switch (clickPosition) {
                    case 'cell':
                    case 'outside':
                    instance.close();
                    break;
                }
            },
            // 设置默认
            checked(idx, event){
                this.$http({
                    url: api.setDefaultAddress,
                    method: 'post',
                    data: {
                        userId: this.userInfo.userId,
                        addressId: this.address[idx]['addressId'],
                        isDefault: this.address[idx]['isdefault'] == 0 ? '1' : '0'
                    }
                }).then(res=>{
                    var msg = '设置成功';
                    if(res.success){
                       setTimeout(()=>{
                           this.queryAddressList();
                       },1300)
                       this.$store.commit({
                            type: 'comment',
                            name: 'curAddress',
                            curAddress: this.address[idx]
                        })
                    }else{
                        msg = res.message
                    }
                    this.$toast({
                        message: msg,
                        forbidClick: true,
                    });
                })
            },
            
            // 增
            addAddress(){
                this.$router.push({
                    name: 'user_change_address'
                })
            },
            // 删
            dele(instance){
                this.$dialog.confirm({
                    message: '确定删除吗？'
                }).then(() => {
                    this.dele_address(instance);
                });
            },
            // 删除请求
            dele_address(_addressId){
                console.log('_addressId',_addressId)
                this.$http({
                    url: api.deleteAddress,
                    method: 'post',
                    data: {
                        addressId: _addressId
                    }
                }).then(res=>{
                    if(res.success){
                        setTimeout(()=>{
                            this.queryAddressList();
                        },1300)
                    }
                    this.$toast({
                            message: res.message,
                            forbidClick: true,
                        });         
                })
            },
            // 编辑
            edit(_item){
                console.log('edit',);
                this.$store.commit({
                    type: 'comment',
                    name: 'editAddress',
                    editAddress: _item
                })
                this.$router.push({
                    name: 'user_change_address'
                })
            },
            // 查询地址列表
            queryAddressList(){
                console.log('queryAddressList');
                var that = this;
                this.$http({
                    url: api.queryAddressList,
                    method: 'post',
                    data: {
                        userId: this.userInfo.userId
                    }
                }).then(res=>{
                    console.log('queryAddressList',res.data)
                    if(res.success){
                        this.address = res.data;
                        this.$store.commit({
                            type: 'comment',
                            name: 'address',
                            address: res.data
                        })
                    }else{
                        this.$toast({
                            message: res.message,
                            forbidClick: true,
                        });
                    }
                })
            },
            //选中地址操作
            checkAddress(idx){
                // console.log(this.$store.state.editOrderAddress);
                console.log(this.params, 'my');
                if(this.params.source == 'my') return;
                if(this.$store.state.editOrderAddress){
                    this.$http({
                        url: api.updateOrderAddress,
                        method: 'post',
                        data: {
                            orderId: this.$store.state.editOrderAddress,
                            addressId: this.address[idx].addressId
                        }
                    }).then(res=>{
                        if(res.success){
                            var orderId = this.$store.state.editOrderAddress;
                            setTimeout(()=>{
                                this.$router.back(-1);
                                // if(this.params.target){
                                //     this.$router.replace({
                                //         name: this.params.target,
                                //         params: {
                                //             orderId: orderId
                                //         }
                                //     })
                                // }else{
                                //     this.$router.back(-1);
                                // }
                            },1200)
                            
                            
                        }
                        this.$toast({
                            message: res.message,
                            forbidClick: true,
                        });
                    })
                }else{
                    this.$store.commit({
                        type: 'comment',
                        name: 'curAddress',
                        curAddress: this.address[idx]
                    })
                    this.$router.back(-1);
                }
            }
        }
    }
</script>

